import { Outlet } from 'react-router-dom'
import Footer from 'ui/src/components/Footer'
import Header from 'components/public/Header'
import { StyledBox } from './styles'

const AppLandingLayout = () => {
  return (
    <>
      <Header />
      <StyledBox>
        <Outlet />
      </StyledBox>
      <Footer />
    </>
  )
}

export default AppLandingLayout
